'use client';

import { useEffect, useState } from 'react';
import Icon from '@/components/ui/AppIcon';
import { MessageCircle } from "lucide-react";

const PHONE_NUMBER = '919876543210'; // Replace with your WhatsApp number

const MESSAGE = encodeURIComponent(
  'Hello, I would like to know more about admissions at Shri R.P. College of Pharmacy.'
);

export default function WhatsAppFloatingButton() {
  const [showBubble, setShowBubble] = useState(false);

  useEffect(() => {
  const timer = setTimeout(() => {
    setShowBubble(true);
  }, 1500);

  return () => clearTimeout(timer);
}, []);

  const closeBubble = () => {
  setShowBubble(false);
};
  return (
    <div data-component-id="src/components/ui/WhatsAppFloatingButton.tsx:28:4" data-component-path="src/components/ui/WhatsAppFloatingButton.tsx" data-component-line="28" data-component-end-line="135" data-component-file="WhatsAppFloatingButton.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22fixed%20bottom-24%20right-6%20z-%5B999%5D%20flex%20flex-col%20items-end%20gap-3%22%7D" className="fixed bottom-24 right-6 z-[999] flex flex-col items-end gap-3">

      {/* Chat Bubble */}

      {showBubble && (
        <div data-component-id="src/components/ui/WhatsAppFloatingButton.tsx:33:8" data-component-path="src/components/ui/WhatsAppFloatingButton.tsx" data-component-line="33" data-component-end-line="78" data-component-file="WhatsAppFloatingButton.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22%5Cn%20%20%20%20%20%20%20%20%20%20%20%20relative%5Cn%20%20%20%20%20%20%20%20%20%20%20%20max-w-%5B280px%5D%5Cn%20%20%20%20%20%20%20%20%20%20%20%20rounded-2xl%5Cn%20%20%20%20%20%20%20%20%20%20%20%20border%5Cn%20%20%20%20%20%20%20%20%20%20%20%20border-white%2F40%5Cn%20%20%20%20%20%20%20%20%20%20%20%20bg-white%2F80%5Cn%20%20%20%20%20%20%20%20%20%20%20%20backdrop-blur-xl%5Cn%20%20%20%20%20%20%20%20%20%20%20%20shadow-2xl%5Cn%20%20%20%20%20%20%20%20%20%20%20%20px-5%5Cn%20%20%20%20%20%20%20%20%20%20%20%20py-4%5Cn%20%20%20%20%20%20%20%20%20%20%20%20animate-%5BfadeIn_.5s_ease%5D%5Cn%20%20%20%20%20%20%20%20%20%20%22%7D"
          className="
            relative
            max-w-[280px]
            rounded-2xl
            border
            border-white/40
            bg-white/80
            backdrop-blur-xl
            shadow-2xl
            px-5
            py-4
            animate-[fadeIn_.5s_ease]
          "
        >
          <button data-component-id="src/components/ui/WhatsAppFloatingButton.tsx:48:10" data-component-path="src/components/ui/WhatsAppFloatingButton.tsx" data-component-line="48" data-component-end-line="53" data-component-file="WhatsAppFloatingButton.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22absolute%20right-3%20top-3%20text-gray-400%20hover%3Atext-gray-700%20transition%22%2C%22textContent%22%3A%22%E2%9C%95%22%7D"
            onClick={closeBubble}
            className="absolute right-3 top-3 text-gray-400 hover:text-gray-700 transition"
          >
            ✕
          </button>

          <p data-component-id="src/components/ui/WhatsAppFloatingButton.tsx:55:10" data-component-path="src/components/ui/WhatsAppFloatingButton.tsx" data-component-line="55" data-component-end-line="57" data-component-file="WhatsAppFloatingButton.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-sm%20font-semibold%20text-foreground%22%2C%22textContent%22%3A%22%F0%9F%91%8B%20How%20can%20we%20help%20you%3F%22%7D" className="text-sm font-semibold text-foreground">
            👋 How can we help you?
          </p>

          <p data-component-id="src/components/ui/WhatsAppFloatingButton.tsx:59:10" data-component-path="src/components/ui/WhatsAppFloatingButton.tsx" data-component-line="59" data-component-end-line="61" data-component-file="WhatsAppFloatingButton.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22mt-1%20text-sm%20text-muted-foreground%20leading-relaxed%22%2C%22textContent%22%3A%22Chat%20with%20our%20admission%20counsellor%20for%20quick%20assistance.%22%7D" className="mt-1 text-sm text-muted-foreground leading-relaxed">
            Chat with our admission counsellor for quick assistance.
          </p>

          <div data-component-id="src/components/ui/WhatsAppFloatingButton.tsx:63:10" data-component-path="src/components/ui/WhatsAppFloatingButton.tsx" data-component-line="63" data-component-end-line="77" data-component-file="WhatsAppFloatingButton.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20absolute%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20-bottom-2%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20right-8%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20w-4%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20h-4%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20rotate-45%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20border-r%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20border-b%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20border-white%2F40%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20bg-white%2F80%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20backdrop-blur-xl%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%22%7D"
            className="
              absolute
              -bottom-2
              right-8
              w-4
              h-4
              rotate-45
              border-r
              border-b
              border-white/40
              bg-white/80
              backdrop-blur-xl
            "
          />
        </div>
      )}

      {/* WhatsApp Button */}

      <a data-component-id="src/components/ui/WhatsAppFloatingButton.tsx:83:6" data-component-path="src/components/ui/WhatsAppFloatingButton.tsx" data-component-line="83" data-component-end-line="133" data-component-file="WhatsAppFloatingButton.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%2C%22className%22%3A%22%5Cn%20%20%20%20%20%20%20%20%20%20group%5Cn%20%20%20%20%20%20%20%20%20%20relative%5Cn%20%20%20%20%20%20%20%20%20%20flex%5Cn%20%20%20%20%20%20%20%20%20%20h-16%5Cn%20%20%20%20%20%20%20%20%20%20w-16%5Cn%20%20%20%20%20%20%20%20%20%20items-center%5Cn%20%20%20%20%20%20%20%20%20%20justify-center%5Cn%20%20%20%20%20%20%20%20%20%20rounded-full%5Cn%20%20%20%20%20%20%20%20%20%20bg-%5B%2325D366%5D%5Cn%20%20%20%20%20%20%20%20%20%20shadow-%5B0_12px_35px_rgba(37%2C211%2C102%2C.45)%5D%5Cn%20%20%20%20%20%20%20%20%20%20transition-all%5Cn%20%20%20%20%20%20%20%20%20%20duration-500%5Cn%20%20%20%20%20%20%20%20%20%20hover%3Ascale-110%5Cn%20%20%20%20%20%20%20%20%22%7D"
        href={`https://wa.me/${PHONE_NUMBER}?text=${MESSAGE}`}
        target="_blank"
        rel="noopener noreferrer"
        className="
          group
          relative
          flex
          h-16
          w-16
          items-center
          justify-center
          rounded-full
          bg-[#25D366]
          shadow-[0_12px_35px_rgba(37,211,102,.45)]
          transition-all
          duration-500
          hover:scale-110
        "
      >
        {/* Pulse */}

        <span data-component-id="src/components/ui/WhatsAppFloatingButton.tsx:105:8" data-component-path="src/components/ui/WhatsAppFloatingButton.tsx" data-component-line="105" data-component-end-line="105" data-component-file="WhatsAppFloatingButton.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22absolute%20inset-0%20rounded-full%20bg-%5B%2325D366%5D%20opacity-30%20animate-ping%22%7D" className="absolute inset-0 rounded-full bg-[#25D366] opacity-30 animate-ping" />

        {/* Icon */}

       <MessageCircle data-component-id="src/components/ui/WhatsAppFloatingButton.tsx:109:7" data-component-path="src/components/ui/WhatsAppFloatingButton.tsx" data-component-line="109" data-component-end-line="109" data-component-file="WhatsAppFloatingButton.tsx" data-component-name="MessageCircle" data-component-content="%7B%22elementName%22%3A%22MessageCircle%22%7D" size={30} color="white" />
        

        {/* Hover Tooltip */}

        <span data-component-id="src/components/ui/WhatsAppFloatingButton.tsx:114:8" data-component-path="src/components/ui/WhatsAppFloatingButton.tsx" data-component-line="114" data-component-end-line="132" data-component-file="WhatsAppFloatingButton.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22%5Cn%20%20%20%20%20%20%20%20%20%20%20%20absolute%5Cn%20%20%20%20%20%20%20%20%20%20%20%20right-20%5Cn%20%20%20%20%20%20%20%20%20%20%20%20whitespace-nowrap%5Cn%20%20%20%20%20%20%20%20%20%20%20%20rounded-full%5Cn%20%20%20%20%20%20%20%20%20%20%20%20bg-black%5Cn%20%20%20%20%20%20%20%20%20%20%20%20px-4%5Cn%20%20%20%20%20%20%20%20%20%20%20%20py-2%5Cn%20%20%20%20%20%20%20%20%20%20%20%20text-xs%5Cn%20%20%20%20%20%20%20%20%20%20%20%20text-white%5Cn%20%20%20%20%20%20%20%20%20%20%20%20opacity-0%5Cn%20%20%20%20%20%20%20%20%20%20%20%20transition-all%5Cn%20%20%20%20%20%20%20%20%20%20%20%20duration-300%5Cn%20%20%20%20%20%20%20%20%20%20%20%20group-hover%3Aopacity-100%5Cn%20%20%20%20%20%20%20%20%20%20%22%2C%22textContent%22%3A%22Chat%20on%20WhatsApp%22%7D"
          className="
            absolute
            right-20
            whitespace-nowrap
            rounded-full
            bg-black
            px-4
            py-2
            text-xs
            text-white
            opacity-0
            transition-all
            duration-300
            group-hover:opacity-100
          "
        >
          Chat on WhatsApp
        </span>
      </a>

    </div>
  );
}